module.exports = __webpack_public_path__ + "img/syblone.4d7b1469.svg";